import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=30f50e52&scoped=true&"
var script = {}
import style0 from "./Form.vue?vue&type=style&index=0&id=30f50e52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f50e52",
  null
  
)

export default component.exports